export const HOME_DELIVERIES_GLOBAL_KEY = 'HOME_DELIVERIES_GLOBAL_KEY';
export const HOME_DELIVERIES_GLOBAL_CENTER_KEY = 'HOME_DELIVERIES_GLOBAL_CENTER_KEY';
export const HOME_DELIVERIES_PLACES_KEY = 'HOME_DELIVERIES_PLACES_KEY';
export const HOME_DELIVERY_PLACE_ONE_KEY = 'HOME_DELIVERY_PLACE_ONE_KEY';
